import logo from './../assets/images/office-free-header-logo.svg'
import Button1 from '../components/ui/Button1'
import { PlanTabs } from '../types/PlanTabs'
import React from 'react'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'

const Logout = () => {
  const history = useHistory()

  let login = () => {
    history.push({
      pathname: '/',
    })
  }
  const { t } = useTranslation()
  return (
    <>
      <div>
        <div className="landing-wrap">
          <div className="img-wrap">
            <img className="img" src={logo} height="120" width="50" alt={''} />
          </div>
        </div>
      </div>

      <h4 className={'success-text'}>
        <b>{t('logout.logout-header')}</b>
      </h4>
      <h5 className={'redirect-text'}>{t('logout.logout-text')}</h5>
      <br />
      <div className="landing-wrap">
        <Button1
          class={'button-blue logout-button-size'}
          label={t('logout.login')}
          onClick={(e) => login()}
          disabled={false}
        />
      </div>
    </>
  )
}

export default Logout
